/**
 * Tema visual compartilhado dos gráficos (0.1.65) — "vidro escuro com luz por trás".
 *
 * Mesmo clima do card de Tendência: fundo navy/roxo com brilhos radiais, para dar
 * profundidade e destaque aos dados. Use `GLASS_CHART_CARD` no contêiner e as
 * constantes de eixo/grade/tooltip nos componentes do recharts.
 */
import type { CSSProperties } from "react";

/** Fundo "vidro escuro" para o cartão que envolve um gráfico. */
export const GLASS_CHART_CARD: CSSProperties = {
  background:
    "radial-gradient(90% 70% at 12% -5%, rgba(99,102,241,0.22), transparent 60%)," +
    "radial-gradient(85% 90% at 105% 115%, rgba(244,63,94,0.14), transparent 55%)," +
    "linear-gradient(160deg,#151b30 0%,#0c1122 58%,#0a0e1b 100%)",
  borderColor: "rgba(255,255,255,0.08)",
  boxShadow: "0 18px 46px rgba(6,10,24,0.55), inset 0 1px 0 rgba(255,255,255,0.06)",
};

/** Cor dos rótulos de eixo (clara, para ler no fundo escuro). */
export const CHART_AXIS = "#8ea0bd";
/** Cor da grade (bem discreta). */
export const CHART_GRID = "rgba(255,255,255,0.06)";
/** Cor do "miolo" do fundo — útil como borda entre fatias de pizza. */
export const CHART_BG = "#0c1122";

/** Estilo do balão de tooltip (fundo escuro translúcido). */
export const CHART_TOOLTIP: CSSProperties = {
  background: "rgba(12,17,34,0.96)",
  border: "1px solid rgba(255,255,255,0.14)",
  borderRadius: 10,
  color: "#e2e8f0",
  boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
};

/** Paleta vibrante para fatias/barras sobre o fundo escuro. */
export const PIE_COLORS_DARK = [
  "#38bdf8", "#a78bfa", "#fb923c", "#34d399", "#f472b6",
  "#facc15", "#22d3ee", "#f87171", "#4ade80", "#c084fc",
  "#60a5fa", "#fbbf24", "#2dd4bf", "#e879f9", "#818cf8",
];
